import React, { useEffect, useState } from "react";
import "../css/Header.css";
import AlmaEconomicsLogo from "../images/almaeconomics_logo_black.svg";
import CityOfLondonLogo from "../images/City_of_London_logo.svg";
import { useNavigate } from "react-router-dom";

const Header = () => {
	let navigate = useNavigate();
	const [activeTab, setActiveTab] = useState("");

	useEffect(() => {
		if (window.location) {
			if (window.location.href.indexOf("data-dashboard") > -1) {
				setActiveTab("Data Dashboard");
			} else if (window.location.href.indexOf("evidence-map") > -1) {
				setActiveTab("Evidence Map");
			} else if (window.location.href.indexOf("service-directory") > -1) {
				setActiveTab("Service Directory");
			} else {
				setActiveTab("Home");
			}
		}
	}, []);

	return (
		<div>
			<div>
				<header className="header-container">
					<a
						href="https://www.cityoflondon.gov.uk/things-to-do"
						target="_blank"
						rel="noreferrer"
						className="header-left-section"
					>
						<img src={CityOfLondonLogo} alt="City of London Logo" />
					</a>
					<div
						className="header-middle-section"
						onClick={() => {
							navigate("/");
							setActiveTab("Home");
						}}
					>
						Pan-London Homeless Substance Use Programme <br />
						Social Isolation and Recovery Project
					</div>
					<a
						href="https://www.almaeconomics.com/"
						target="_blank"
						rel="noreferrer"
						className="header-right-section"
					>
						<img
							src={AlmaEconomicsLogo}
							alt="Alma Economics Logo"
						/>
					</a>
				</header>
				<header className="header-container-mobile">
					<div className="header-logo-section">
						<a
							href="https://www.cityoflondon.gov.uk/things-to-do"
							target="_blank"
							rel="noreferrer"
							className="header-left-section"
						>
							<img
								src={CityOfLondonLogo}
								alt="City of London Logo"
							/>
						</a>

						<a
							href="https://www.almaeconomics.com/"
							target="_blank"
							rel="noreferrer"
							className="header-right-section"
						>
							<img
								src={AlmaEconomicsLogo}
								alt="Alma Economics Logo"
							/>
						</a>
					</div>
					<div
						className="header-middle-section"
						onClick={() =>
							window.location.pathname !== "/" && navigate("/")
						}
					>
						Pan-London Homeless Substance Use Programme
						<br />
						Social Isolation and Recovery Project
					</div>
				</header>
			</div>
			<div
				className="navigation-bar-container"
				style={{
					borderBottom:
						activeTab === "Home" ? "none" : "1px solid #1e1e1e",
				}}
			>
				<nav className="navigation-bar">
					<a
						className={activeTab === "Home" ? "active-tab" : ""}
						href="/"
					>
						Home
					</a>
					<a
						className={
							activeTab === "Evidence Map" ? "active-tab" : ""
						}
						href="/evidence-map/"
					>
						Evidence Map
					</a>
					<a
						className={
							activeTab === "Service Directory"
								? "active-tab"
								: ""
						}
						href="/service-directory/"
					>
						Service Directory
					</a>
					<a
						className={
							activeTab === "Data Dashboard" ? "active-tab" : ""
						}
						href="/data-dashboard/"
					>
						Data Dashboard
					</a>
				</nav>
			</div>
		</div>
	);
};

export default Header;
